import React, { useState } from 'react';
import { writings } from '../data/writings';
import useScrollReveal from '../hooks/useScrollReveal';
import './Writing.css';

function Writing() {
  const [gridRef, gridVisible] = useScrollReveal();
  const [showAll, setShowAll] = useState(false);
  const visibleWritings = showAll ? writings : writings.slice(0, 3);

  return (
    <section className="writing section" id="writing">
      <div className="container">
        <h2 className="section-title">
          Featured <span className="gold-accent">Writings</span>
        </h2>
        <p className="section-subtitle">
          Miriam's writing spans AI, Extremism, Middle Eastern Politics, Female Empowerment and more
        </p>

        <div ref={gridRef} className={`writing__grid reveal-children ${gridVisible ? 'visible' : ''}`}>
          {visibleWritings.map((w) => (
            <a
              key={w.id}
              href={w.url}
              target="_blank"
              rel="noopener noreferrer"
              className="writing__card"
            >
              <div className="writing__card-accent" />
              <span className="writing__publication">{w.publication}</span>
              <h3 className="writing__title">{w.title}</h3>
              <span className="writing__read">Read Article →</span>
            </a>
          ))}
        </div>

        {writings.length > 3 && (
          <div className="writing__more">
            <button className="writing__more-btn" onClick={() => setShowAll(!showAll)}>
              {showAll ? 'Show Less' : 'See More Writings'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Writing;
